import React, { PureComponent } from 'react';
import dayjs from 'dayjs';
import {
  Form,
  Button,
  Input,
  Table,
  DatePicker,
  TreeSelect,
  message,
  Card,
  Select,
  Popover,
  Row,
  Col,
} from 'antd-v5';
import { DownloadOutlined, EditOutlined } from '@ant-design/icons';
import { Select as UiSelect } from '@/components';
import PageHeaderLayout from '../../../component/page-header-layout/index';
import { addDownloadRecordRequest, generatePdfRequest } from '../../../state/request/bank';
import { generalParamsWithPToStr } from '../../../utils/math';
import { API_ADMIN } from '../../../utils/urls';
import { exportFile } from '../../../utils/utils';

import './index.less';
import {
  exportPayEntryDataRequest,
  fetchPayEntryDataRequest,
  getPayEntryRatioOptionsRequest,
  removePayEntryDataRequest,
  updatePayEntryStatusRequest,
} from '../../../state/request/payEntryData';
import { marketList } from '../../../state/request/stall';
import { getAllDistrictInfo } from '../../../state/request/mergeSet';
import ImportResult from './importResult';
import RepaymentImportResult from './repaymentImportResult';
import EditBuyer from './editBuyer';
import EditRepaymentAmount from './editRepaymentAmount';
import AddRecordItem from './addRecordItem';
const TYPE_ENUM = {
  xu_song_cui_kuan: 8,
  wei_tuo_cui_kuan: 3,
};
const SOURCE_ENUM = {
  INTEGRATIONAPP: 'INTEGRATIONAPP',
  ANDROID: 'android',
  PURCHASEAPI: 'PURCHASEAPI',
  WEB: 'web',
  ADMIN: 'ADMIN',
};
const FOLLOW_OPERATION_ENUM = {
  dai_wei_tuo: 0,
  wei_tuo: 1,
  bu_wei_tuo: 2,
  ji_lu_zuo_fei: 3,
  jie_an: 4,
};
const PROCESS_STATUS_ENUM = {
  UNCOMPLETED: 0,
  COMPLETED: 1,
};
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const initParams = {};
class BankPayment extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      params: initParams,
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      pageList: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      repaymentImportVisible: false,
      editBuyerVisible: false,
      editRepaymentAmountVisible: false,
      addRecordItemVisible: false,
      cityOptions: [],
      marketOptions: [],
      ratioOptions: [],
    };
    this.sourceList = [
      { value: SOURCE_ENUM.INTEGRATIONAPP, label: 'APP' },
      { value: SOURCE_ENUM.ADMIN, label: '手工' },
    ];
    this.followOperationList = [
      { value: FOLLOW_OPERATION_ENUM.dai_wei_tuo, label: '待委托' },
      { value: FOLLOW_OPERATION_ENUM.wei_tuo, label: '委托' },
      { value: FOLLOW_OPERATION_ENUM.ji_lu_zuo_fei, label: '作废' },
      { value: FOLLOW_OPERATION_ENUM.jie_an, label: '结案' },
    ];
    this.processStatusList = [
      { value: PROCESS_STATUS_ENUM.UNCOMPLETED, label: '未完成' },
      { value: PROCESS_STATUS_ENUM.COMPLETED, label: '已完成' },
    ];
    this.formRef = null;
    this.columns = [
      {
        title: '案件ID',
        dataIndex: 'id',
        width: 120,
        fixed: 'left',
      },
      {
        title: '来源',
        dataIndex: 'source',
        render: (text) => {
          return this.sourceList.find((item) => item.value === text)?.label || text || '';
        },
      },
      {
        title: '商行业务ID',
        dataIndex: 'businessCode',
      },
      {
        title: '商行名称',
        dataIndex: 'stallName',
      },
      {
        title: '城市',
        dataIndex: 'cityName',
        render: (text, record) => {
          return `${record.provinceName || ''} ${record.cityName || ''} `;
        },
      },
      {
        title: '所在市场',
        dataIndex: 'marketName',
      },
      {
        title: '联系人姓名',
        dataIndex: 'contactName',
      },
      {
        title: '联系人手机号',
        dataIndex: 'contactPhone',
      },
      {
        title: '买家ID',
        dataIndex: 'debtorId',
        render: (text, record) => {
          return record.debtorId || '';
        },
      },
      {
        title: '被追讨人姓名',
        dataIndex: 'debtorName',
        render: (text, record) => {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: record.source === SOURCE_ENUM.ADMIN ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (
                  record.source === SOURCE_ENUM.ADMIN &&
                  record.status !== FOLLOW_OPERATION_ENUM.jie_an
                ) {
                  this.setState({ editBuyerVisible: true, editBuyerData: record });
                }
              }}
            >
              {text}
              {record.source === SOURCE_ENUM.ADMIN &&
                record.status !== FOLLOW_OPERATION_ENUM.jie_an && (
                  <EditOutlined style={{ marginLeft: 4, color: '#01b755' }} />
                )}
            </div>
          );
        },
      },
      {
        title: '被追讨人手机号',
        dataIndex: 'debtorPhone',
        render: (text, record) => {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: record.source === SOURCE_ENUM.ADMIN ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (
                  record.source === SOURCE_ENUM.ADMIN &&
                  record.status !== FOLLOW_OPERATION_ENUM.jie_an
                ) {
                  this.setState({ editBuyerVisible: true, editBuyerData: record });
                }
              }}
            >
              {text}
              {record.source === SOURCE_ENUM.ADMIN &&
                record.status !== FOLLOW_OPERATION_ENUM.jie_an && (
                  <EditOutlined style={{ marginLeft: 4, color: '#01b755' }} />
                )}
            </div>
          );
        },
      },
      {
        title: '追讨标的金额',
        dataIndex: 'creditAmount',
        render: (text) => (text ? `¥${Number(text).toLocaleString()}` : '¥0'),
      },
      {
        title: '佣金比例',
        dataIndex: 'ratio',
        render: (ratio) => (ratio == null ? '' : `${ratio}%`),
      },
      {
        title: '委托记录创建时间',
        dataIndex: 'delegateCreateTime',
        render: (text) => {
          return text ? dayjs(text).format('YYYY-MM-DD') : '';
        },
      },
      {
        title: '回款金额',
        dataIndex: 'totalRepaymentAmount',
        render: (text, record) => {
          const amountText = text ? `\u00A5${Number(text).toLocaleString()}` : '\u00A50';
          const canEdit = record.status === FOLLOW_OPERATION_ENUM.wei_tuo;
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: canEdit ? 'pointer' : 'default',
              }}
              onClick={() => {
                if (canEdit) {
                  this.setState({
                    editRepaymentAmountVisible: true,
                    editRepaymentAmountData: record,
                  });
                }
              }}
            >
              {amountText}
              {canEdit && <EditOutlined style={{ marginLeft: 4, color: '#01b755' }} />}
            </div>
          );
        },
      },
      {
        title: '跟进操作',
        dataIndex: 'status',
        render: (text, record) => {
          const displayStatus =
            text === FOLLOW_OPERATION_ENUM.bu_wei_tuo ? FOLLOW_OPERATION_ENUM.ji_lu_zuo_fei : text;
          return (
            <Select
              placeholder='选择'
              style={{ width: 100 }}
              disabled={record.processStatus === PROCESS_STATUS_ENUM.COMPLETED}
              options={this.followOperationList.map((item) => ({
                ...item,
                disabled: this.isFollowOperationDisabled(displayStatus, item.value),
              }))}
              value={isNaN(displayStatus) ? null : displayStatus}
              onChange={(value) => {
                this.changeStatus(record, value);
              }}
            />
          );
        },
      },

      {
        title: '下载',
        dataIndex: 'id',
        render: (_, record) => {
          if (record.type === 3) {
            return (
              <Button
                type='link'
                size='small'
                danger={!record.pdfUrl}
                style={{ margin: 0, border: 'none' }}
                onClick={this.downloadPdf.bind(this, record)}
              >
                {record.pdfUrl ? '协议文件' : '生成协议'}
              </Button>
            );
          }
          return (
            <Button
              type='link'
              size='small'
              style={{ margin: 0, border: 'none' }}
              onClick={() => {
                this.downloadFile(record.id, record.stallName);
              }}
            >
              协议文件
            </Button>
          );
        },
      },
    ];
  }

  isFollowOperationDisabled = (currentStatus, targetStatus) => {
    const disabledStatusMap = {
      [FOLLOW_OPERATION_ENUM.dai_wei_tuo]: [FOLLOW_OPERATION_ENUM.jie_an],
      [FOLLOW_OPERATION_ENUM.wei_tuo]: [FOLLOW_OPERATION_ENUM.dai_wei_tuo],
      [FOLLOW_OPERATION_ENUM.ji_lu_zuo_fei]: [
        FOLLOW_OPERATION_ENUM.dai_wei_tuo,
        FOLLOW_OPERATION_ENUM.wei_tuo,
        FOLLOW_OPERATION_ENUM.jie_an,
      ],
      [FOLLOW_OPERATION_ENUM.jie_an]: [
        FOLLOW_OPERATION_ENUM.dai_wei_tuo,
        FOLLOW_OPERATION_ENUM.wei_tuo,
        FOLLOW_OPERATION_ENUM.ji_lu_zuo_fei,
      ],
    };

    return disabledStatusMap[currentStatus]?.includes(targetStatus) || false;
  };

  //初始加载
  componentDidMount() {
    this.loadFilterOptions();
    this.doRequest();
  }

  loadFilterOptions = async () => {
    const [districtRes, marketRes, ratioRes] = await Promise.all([
      getAllDistrictInfo(),
      marketList({}),
      getPayEntryRatioOptionsRequest(),
    ]);
    const districtData = districtRes?.data;
    const marketData = marketRes?.data;
    const { mapping } = districtData || {};
    const { origins } = mapping || [];
    //去掉区
    if (origins instanceof Array) {
      for (const iterator of origins) {
        for (const iteratorChildren of iterator.children) {
          delete iteratorChildren.children;
        }
      }
    }
    const marketOptions = Array.isArray(marketData)
      ? marketData.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      : [];
    const ratioOptions =
      ratioRes?.code === 200 && Array.isArray(ratioRes.data)
        ? ratioRes.data.map((ratio) => ({ label: `${ratio}%`, value: ratio }))
        : [];
    this.setState({ cityOptions: origins, marketOptions, ratioOptions });
  };

  doRequest = async () => {
    const { pageNo, pageSize, params } = this.state;
    console.log('pageNo, pageSize, params: ', pageNo, pageSize, params);
    const { createTimeRange, latestRepaymentTime, businessCode, ...rest } = params;
    if (latestRepaymentTime && !businessCode) {
      message.warning('选中还款时间，必须填写商行业务ID');
      return;
    }
    this.setState({ loading: true });
    const { code, data } = await fetchPayEntryDataRequest({
      pageNo,
      pageSize,
      startTime: createTimeRange?.[0]?.valueOf(),
      endTime: createTimeRange?.[1]?.valueOf(),
      latestRepaymentTime: latestRepaymentTime?.valueOf(),
      businessCode,
      ...rest,
    });
    this.setState({ loading: false });
    if (code === 200) {
      this.setState({
        pageList: data.pageList,
        totalSize: data.totalSize,
        selectedRows: [],
        selectedRowKeys: [],
      });
    }
  };

  changeStatus = async (record, status) => {
    const { code } = await updatePayEntryStatusRequest({
      id: record.id,
      status,
    });
    if (code === 200) {
      message.success('操作成功');
      this.doRequest();
    }
  };

  //提交请求
  handleSubmit = (values) => {
    this.setState({ pageNo: 1, params: values }, this.doRequest);
  };

  // 分页切换
  pageSwitch = (obj) => {
    this.setState({ pageNo: obj.current }, this.doRequest);
  };
  //重置
  handleReset = () => {
    this.formRef.resetFields();
    this.setState({ pageNo: 1, params: initParams }, this.doRequest);
  };
  exportFile = async () => {
    const fieldsValue = await this.formRef.getFieldsValue();
    const { createTimeRange, latestRepaymentTime, businessCode, ...rest } = fieldsValue;
    if (latestRepaymentTime && !businessCode) {
      message.warning('选中还款时间，必须填写商行业务ID');
      return;
    }
    const startDT = createTimeRange?.[0];
    const endDT = createTimeRange?.[1];
    if (!endDT || !startDT) {
      message.warning('目前支持导出从当前日期开始一年的数据，请重新选择创建时间。');
      return;
    }
    const daysDiff = dayjs(startDT).add(1, 'year').isBefore(dayjs(endDT));
    if (daysDiff) {
      message.warning('目前支持导出从当前日期开始一年的数据，请重新选择创建时间。');
      return;
    }
    this.handleSubmit(fieldsValue);
    const response = await exportPayEntryDataRequest({
      startTime: startDT?.valueOf(),
      endTime: endDT?.valueOf(),
      latestRepaymentTime: latestRepaymentTime?.valueOf(),
      businessCode,
      ...rest,
    });
    exportFile(response, '催收服务统计汇总信息.xlsx');
  };

  importFile = () => {
    this.setState({ visible: true });
  };

  addRecord = () => {
    this.setState({ addRecordItemVisible: true });
  };

  deleteFile = async () => {
    const { selectedRows } = this.state;
    if (selectedRows.length === 0) {
      message.warning('请选择要删除的数据');
      return;
    }
    const { code } = await removePayEntryDataRequest({
      idList: selectedRows.map((item) => item.id),
    });
    if (code === 200) {
      message.success('删除成功');
      this.setState({ selectedRows: [], pageNo: 1 }, this.doRequest);
    }
  };

  getExtraContent() {
    const layout = { xs: 24, sm: 12, md: 8, lg: 6, xl: 6 };
    const { cityOptions, marketOptions, ratioOptions } = this.state;
    return (
      <div className='wrapper'>
        <Form
          ref={(r) => {
            this.formRef = r;
          }}
          onFinish={this.handleSubmit}
          initialValues={initParams}
        >
          <Row gutter={24}>
            <Col span={6}>
              <FormItem name='id' label='案件ID'>
                <Input placeholder='请输入案件ID' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='source' label='来源'>
                <Select placeholder='来源' allowClear options={this.sourceList} />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='districtList' label='城市'>
                <TreeSelect
                  allowClear
                  multiple
                  maxTagCount={2}
                  showSearch
                  treeData={cityOptions}
                  placeholder='请选择城市'
                  treeDefaultExpandAll={false}
                  filterTreeNode={(input, treeNode) => {
                    return treeNode?.title?.indexOf(input) >= 0;
                  }}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='marketIdList' label='市场'>
                <Select
                  placeholder='请选择市场'
                  allowClear
                  mode='multiple'
                  maxTagCount={2}
                  showSearch
                  options={marketOptions}
                  optionFilterProp='label'
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='businessCode' label='商行业务ID'>
                <Input placeholder='商行业务ID' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='stallName' label='商行名称'>
                <Input placeholder='商行名称' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='phone' label='手机号'>
                <Input placeholder='搜索手机号' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='ratio' label='佣金比例'>
                <UiSelect placeholder='全部' showSearch allowClear options={ratioOptions} />
              </FormItem>
            </Col>
            <Col span={6}>
              <Form.Item name='createTimeRange' label='记录创建时间'>
                <RangePicker
                  disabledDate={(current) => {
                    return current && current > dayjs().endOf('day');
                  }}
                  format='YYYY-MM-DD'
                  placeholder={['开始时间', '结束时间']}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='latestRepaymentTime' label='最近一次还款时间'>
                <DatePicker
                  style={{ width: '100%' }}
                  format='YYYY-MM-DD'
                  placeholder={'最近一次还款时间'}
                  disabledDate={(current) => {
                    return current && current > dayjs().endOf('day');
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='status' label='跟进操作'>
                <Select placeholder='跟进操作' allowClear options={this.followOperationList} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className='action-bar-row'>
                <div className='action-bar'>
                  <Button type='primary' htmlType='submit'>
                    查询
                  </Button>
                  <Button onClick={this.handleReset}>重置</Button>
                  <Button onClick={this.exportFile}>导出</Button>
                  <Button onClick={this.addRecord}>录入</Button>
                  <Popover
                    placement='bottomLeft'
                    overlayStyle={{ maxWidth: '600px' }}
                    content={
                      <div style={{ padding: '8px', display: 'flex' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          催收服务统计导入模版.xlsx
                        </div>
                        <Button
                          type='primary'
                          size='small'
                          icon={<DownloadOutlined />}
                          style={{ marginLeft: '8px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              'https://files.caixm.cn/prod/template/900/%E5%82%AC%E6%94%B6%E6%9C%8D%E5%8A%A1%E7%BB%9F%E8%AE%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
                            );
                          }}
                        >
                          下载
                        </Button>
                      </div>
                    }
                  >
                    <Button onClick={this.importFile}>导入</Button>
                  </Popover>
                  <Popover
                    placement='bottomLeft'
                    overlayStyle={{ maxWidth: '600px' }}
                    content={
                      <div style={{ padding: '8px', display: 'flex' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          回款导入模版.xlsx
                        </div>
                        <Button
                          type='primary'
                          size='small'
                          icon={<DownloadOutlined />}
                          style={{ marginLeft: '8px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              'https://files.caixm.cn/prod/template/900/%E5%AF%BC%E5%85%A5%E5%9B%9E%E6%AC%BE.xlsx',
                            );
                          }}
                        >
                          下载
                        </Button>
                      </div>
                    }
                  >
                    <Button onClick={() => this.setState({ repaymentImportVisible: true })}>
                      导入回款
                    </Button>
                  </Popover>
                  <Button danger onClick={this.deleteFile}>
                    批量删除
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  downloadPdf = async (record) => {
    if (record.pdfUrl) {
      addDownloadRecordRequest({ id: record.id, stallId: record.stallId });
      window.open(record.pdfUrl, '_blank');
    } else {
      const res = await generatePdfRequest({ id: record.id });
      if (res.code === 200) {
        message.success('操作成功');
        this.doRequest();
      }
    }
  };

  downloadFile = (id, stallName) => {
    let params = {};
    window.open(
      API_ADMIN +
        'payEntryDataResource/download/' +
        id +
        '?stallName=' +
        stallName +
        '&' +
        generalParamsWithPToStr('payEntryDataResource/download/' + id, params),
    );
  };

  render() {
    const {
      pageList = [],
      pageNo,
      pageSize,
      totalSize,
      loading,
      visible,
      repaymentImportVisible,
      editBuyerData,
      editBuyerVisible,
      editRepaymentAmountData,
      editRepaymentAmountVisible,
      selectedRows,
      selectedRowKeys,
      addRecordItemVisible,
    } = this.state;
    console.log('this.state: ', this.state);
    const extraContent = this.getExtraContent();

    const pagination = {
      pageSize: pageSize,
      current: pageNo,
      total: totalSize,
      showSizeChanger: true,
      onShowSizeChange: (current, pageSize) => {
        this.setState({ pageSize, pageNo: 1 }, this.doRequest);
      },
    };
    return (
      <PageHeaderLayout>
        <Card bordered={false}>
          {extraContent}
          <Table
            rowKey={(record) => record.id}
            dataSource={pageList}
            columns={this.columns}
            pagination={pagination}
            onChange={this.pageSwitch}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            rowSelection={{
              fixed: true,
              selectedRowKeys,
              onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.setState({ selectedRows, selectedRowKeys });
              },
              getCheckboxProps: (record) => ({
                disabled:
                  record.source === SOURCE_ENUM.INTEGRATIONAPP ||
                  ![FOLLOW_OPERATION_ENUM.bu_wei_tuo, FOLLOW_OPERATION_ENUM.ji_lu_zuo_fei].includes(
                    record.status,
                  ),
              }),
            }}
          />
        </Card>
        <ImportResult
          visible={visible}
          onClose={() => this.setState({ visible: false })}
          onRefresh={() => this.doRequest()}
        />
        <RepaymentImportResult
          visible={repaymentImportVisible}
          onClose={() => this.setState({ repaymentImportVisible: false })}
          onRefresh={() => this.doRequest()}
        />
        {editBuyerVisible && (
          <EditBuyer
            data={editBuyerData}
            visible={editBuyerVisible}
            onClose={() => this.setState({ editBuyerVisible: false })}
            onRefresh={() => this.doRequest()}
          />
        )}
        {editRepaymentAmountVisible && (
          <EditRepaymentAmount
            data={editRepaymentAmountData}
            visible={editRepaymentAmountVisible}
            onClose={() => this.setState({ editRepaymentAmountVisible: false })}
            onRefresh={() => this.doRequest()}
          />
        )}
        {addRecordItemVisible && (
          <AddRecordItem
            visible={addRecordItemVisible}
            onClose={() => this.setState({ addRecordItemVisible: false })}
            onRefresh={() => this.doRequest()}
          />
        )}
      </PageHeaderLayout>
    );
  }
}
export default BankPayment;
